module.exports = __webpack_public_path__ + "img/logo-header.0e1e403d.png";